export const FILTER_TYPE_MSISDN = "msisdn";
export const FILTER_TYPE_ICCID = "iccid";
